import { CloseWhiteIcon, WarningWhiteIcon } from 'components/icons';
import classNames from 'classnames';
import React, { memo, PropsWithChildren } from 'react';
import styles from './Notification.module.scss';
import Text from '../Typography/Text';

export type NotificationProps = {
  dataTest?: string;
  onClose?: () => void;
  text?: string;
  type: 'error' | 'success';
};

export default memo(function Notification({
  onClose,
  text,
  type,
  dataTest = 'notification',
}: PropsWithChildren<NotificationProps>) {
  const dataTestBase = `${dataTest}-${type}`;
  return (
    <div
      className={classNames(styles.notification, styles[`${type}`])}
      data-test={dataTestBase}
    >
      {type === 'error' && (
        <span className={styles['warning-icon']}>
          <WarningWhiteIcon data-test={`${dataTestBase}-icon`} />
        </span>
      )}
      {!!text && (
        <Text
          className={styles.text}
          suppressDefaultStyles
          dangerouslySetInnerHTML={{ __html: text }}
          dataTest={`${dataTestBase}-text`}
        />
      )}
      <span className={styles['close-icon']}>
        <button
          className={styles['close-icon']}
          onClick={onClose}
          data-test={`${dataTestBase}-button`}
        >
          <CloseWhiteIcon data-test={`${dataTestBase}-close-icon`} />
        </button>
      </span>
    </div>
  );
});
